import React, { useEffect, useState, Suspense, lazy } from 'react'
import { useDispatch } from 'react-redux'
import * as ls from 'local-storage'
import { useSearchParams } from 'react-router-dom'
import { useReduxSelector } from '../hooks'
import { ConstantsAction } from '../store/constants'
import { AuthAction } from '../store/auth'
import { GreetingsShow } from '../store/greetings'
import { authSession } from '../api'

const AppLazy = lazy(() => import('./app-lazy'))

const App: React.FC = (): JSX.Element => {
  const dispatch = useDispatch()
  const [searchParams, setSearchParams] = useSearchParams()
  const [message, setMessage] = useState<boolean>(false)

  const { REACT_APP_DEBUG: DEBUG, REACT_APP_PORTAL_URL: PORTAL } = process.env

  const {
    constants: { data: constants },
  } = useReduxSelector((state) => state)

  useEffect(() => {
    if (constants == null) {
      setTimeout(() => {
        dispatch(ConstantsAction({ onSuccess: () => setMessage(true) }))
      }, 700)
    }

    if (searchParams.has('uuid')) {
      const uuid = searchParams.get('uuid') || ''

      setSearchParams(undefined)

      authSession({ uuid })
        .then((res) => {
          if (res.status === 1) {
            ls.set('token_private', { access_token: res.data.token })
            dispatch(AuthAction({}))
          } else {
            window.location.href = `${PORTAL}`
          }
        })
        .catch(() => {
          window.location.href = `${PORTAL}`
        })
    } else if (!ls.get('token_private') && !DEBUG) {
      window.location.href = `${PORTAL}`
    } else {
      dispatch(AuthAction({}))
    }
  }, [])

  useEffect(() => {
    if (constants && constants.IS_PROJECT_START_ACTION && !constants.IS_PROJECT_STOP_ACTION) {
      // оповещение во время акции
      // dispatch(GreetingsShow(stopAction))
    } else if (constants && constants.IS_PROJECT_STOP_ACTION) {
      // оповещение о завершении акции
      // dispatch(GreetingsShow(stopAction))
    }
  }, [message])

  return (
    <Suspense fallback={<></>}>
      <AppLazy />
    </Suspense>
  )
}

export default App
